import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/header/Header1.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import api from "../api";
import { toast } from "react-toastify";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSnowflake,
  faFire,
  faBath,
  faToilet,
  faGift,
  faTv,
  faWineBottle,
  faChair,
  faChildren,
  faWheelchair,
  faWind,
  faSwimmingPool,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

import sliderImages from "../assets/index.js";
import HelpTooltip from "../components/help/HelpTooltip.jsx";
import "../styles/main.css";
ReactModal.setAppElement('#root');

const HomePage = () => {
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3001";
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedAccommodation, setSelectedAccommodation] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [checkin, setCheckin] = useState("");
  const [checkout, setCheckout] = useState("");
  const navigate = useNavigate();
  const hoje = new Date().toISOString().split("T")[0];

  const [accommodations, setAccommodations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reviews = [
    {
      platform: "Airbnb",
      rating: "5.0",
      text: "Bem fácil de achar o local, os anfitriões são super receptivos e nos deixaram bem a vontade, chegamos e encontramos o chalé extremamente limpo, com o ar e a hidromassagem já ligados. Com certeza voltaremos mais vezes! A chácara é linda, dá para pescar e descansar tranquilo nas redes.",
      author: "William",
      date: "Outubro de 2025",
    },
    {
      platform: "Airbnb",
      rating: "5.0",
      text: "O local é muito aconchegante, os anfitriões são muito simpáticos. O café da manhã também estava excelente e foi adaptado para nossas restrições alimentares. Muito obrigado!",
      author: "Rafael",
      date: "Agosto de 2025",
    },
    {
      platform: "Google",
      rating: "5.0",
      text: "O lugar é maravilhoso, muito lindo, cada detalhe para a gente se sentir em casa, tem muita natureza, um lago lindo de frente para o chalé, é muito gostoso dentro do chalé, a cama é maravilhosa, tudo é confortável, os proprietários são muito simpáticos e deram toda assistência, a experiência realmente é inesquecível, bem romântico 🥰",
      author: "Luciane Oliveira",
      date: "Outubro de 2025",
    },
    {
      platform: "Google",
      rating: "5.0",
      text: "Lindo chalé em uma linda chácara! Um lugar super romântico e aconchegante, com certeza a experiência foi inesquecível. Os anfitriões super gentis e deixou a estadia ainda mais agradável, sempre atencioso e prestativo. Nota mil para o chácara, vale super a pena conhecer! Gratidão 🙏🏼",
      author: "Thiago Izídio",
      date: "Setembro de 2025",
    },
    {
      platform: "Booking.com",
      rating: "10.0",
      text: "Tudo limpo e organizado para nos esperar, fomos muito bem recebidos e adorei todo o momento que estivemos lá. Ainda tivemos um mimo com a decoração quando ela soube que era nossa comemoração de um ano de casamento. Indico o local.",
      author: "Priscila",
      date: "Setembro de 2025",
    },
    {
      platform: "Booking.com",
      rating: "10.0",
      text: "Ótimo atendimento; café da manhã incrível. Conforto da roupa de cama, das toalhas e da banheira de hidromassagem, com regulação eletrônica de temperatura.",
      author: "Rodrigo",
      date: "Julho de 2025",
    },
  ];

  useEffect(() => {
    if (modalIsOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalIsOpen]);

  const featureIcons = {
    "Ar condicionado": faSnowflake,
    Lareira: faFire,
    "Banheira de hidromassagem": faBath,
    Banheiro: faToilet,
    "Amenities de banho gratuitas": faGift,
    "TV de tela plana": faTv,
    Frigobar: faWineBottle,
    Varanda: faChair,
    "Aceitamos crianças": faChildren,
    "Sofá cama": faChair,
    Ventilador: faWind,
    "Acessível para mobilidade reduzida": faWheelchair,
    "Piscina privativa": faSwimmingPool,
  };

  useEffect(() => {
    const fetchAccommodations = async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/acomodacoes");
        
        const processedData = data
          .filter(item => item.ativo)
          .map(item => {
            let accommodation = { ...item };

            if (!Array.isArray(accommodation.caracteristicas)) {
              accommodation.caracteristicas = [];
            }

            return accommodation;
          });

        setAccommodations(processedData);
        setError("");
      } catch (err) {
        console.error("Erro ao buscar acomodações:", err);
        setError(
          "Não foi possível carregar as acomodações. Tente novamente mais tarde."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAccommodations();
  }, []);

  const openModal = (accommodation) => {
    setSelectedAccommodation(accommodation);
    setCurrentImageIndex(0);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedAccommodation(null);
  };

  const nextImage = () => {
    if (selectedAccommodation) {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % selectedAccommodation.imagens?.length
      );
    }
  };

  const prevImage = () => {
    if (selectedAccommodation) {
      setCurrentImageIndex(
        (prevIndex) =>
          (prevIndex - 1 + selectedAccommodation.imagens?.length) %
          selectedAccommodation.imagens?.length
      );
    }
  };

  const handleReservarAgora = () => {
    if (!checkin || !checkout) {
      toast.warn(
        "Por favor, selecione a data de entrada e saída para continuar."
      );
      return;
    }

    const dataEntrada = new Date(`${checkin}T00:00:00`);
    const dataSaida = new Date(`${checkout}T00:00:00`);

    if (dataSaida <= dataEntrada) {
      toast.warn("A data de saída deve ser posterior à data de entrada.");
      return;
    }

    if (selectedAccommodation && selectedAccommodation.min_diaria) {
      const dias = Math.ceil((dataSaida - dataEntrada) / (1000 * 60 * 60 * 24));

      if (dias < selectedAccommodation.min_diaria) {
        toast.warn(
          `Esta acomodação exige um período mínimo de ${selectedAccommodation.min_diaria} diária(s).`
        );
        return;
      }
    }

    navigate("/reservas", {
      state: {
        checkin: checkin,
        checkout: checkout,
        acomodacaoInicial: [selectedAccommodation],
      },
    });
  };

  return (
    <div className="homepage">
      <Header mostrarInicio={false} />

      <section>
        <Swiper
          className="hero-slider"
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          effect="fade"
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          slidesPerView={1}
        >
          {sliderImages.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Pousada Chácara dos Pinheiros - Imagem ${index + 1}`}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <main className="main">
        <section className="intro-section">
          <h2 className="intro-title"> Primeira pousada em Imbituva/PR!</h2>
          <p className="intro-text">
            Seja bem-vindo aos Chalés Chácara dos Pinheiros, descubra um refúgio
            para quem busca tranquilidade, aconchego e conexão com a natureza,
            sem abrir mão do conforto e das comodidades da cidade.
          </p>
        </section>

        <section id="sobre" className="info-section">
          <div className="info-row">
            <div className="info-text-content">
              <h3 className="infosection-title">Sobre Nós</h3>
              <p className="info-text">
                Nosso espaço foi cuidadosamente planejado para proporcionar uma
                experiência memorável em todas as épocas do ano, especialmente
                para quem deseja relaxar ou celebrar momentos especiais. Prezamos pelo bem-estar
                dos nossos hóspedes, oferecendo acomodações confortáveis e
                serviços personalizados.
              </p>
            </div>
            <div className="info-image-content">
              <img
                src={sliderImages[5]}
              />
            </div>
          </div>

          <div className="info-row">
            <div className="info-text-content">
              <h3 className="infosection-title">Localização Privilegiada</h3>
              <p className="info-text">
                A pousada possui fácil acesso, apenas 150 metros de estrada de
                chão até a propriedade. Estamos localizados a 10km do centro de
                Imbituva, cerca de 30 minutos de Prudentópolis e a 2 horas de
                Curitiba, a capital do Paraná.
              </p>
            </div>
            <div className="info-image-content">
              <iframe
                className="mapa"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.819826073434!2d-50.655362124619074!3d-25.175560877724916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94e861c43ec9809b%3A0x49a60909adc3c5b8!2sPousada%20Ch%C3%A1cara%20dos%20Pinheiros!5e0!3m2!1spt-BR!2sbr!4v1753138732152!5m2!1spt-BR!2sbr"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          <div className="info-row">
            <div className="info-text-content">
              <h3 className="infosection-title">Estrutura Completa</h3>
              <p className="info-text">
                Com apenas três acomodações exclusivas, nossos chalés foram pensados em proporcional
                tranquilidade e conforto. Um refúgio no campo, rodeado por pinheiros e a natureza,
                perfeito para relaxar e recarregar as energias, e com todas as comodidades da cidade.
              </p>
            </div>
            <div className="info-image-content">
              <img
                src={sliderImages[1]}
              />
            </div>
          </div>

          <div className="info-row">
            <div className="info-text-content">
              <h3 className="infosection-title">Quiosque Deck</h3>
              <p className="info-text">
                Um convite ao relaxamento à beira d'água. Nosso quiosque
                rústico, suspenso sobre um lago, é de uso exclusivo para
                hóspedes e o local perfeito para pesca. Desfrute de momentos de paz ou leitura inesquecível em meio à natureza.
              </p>
            </div>
            <div className="info-image-content">
              <img src={require("../assets/quiosque.jpg")} alt="Quiosque deck sobre o lago" />
            </div>
          </div>

          <div className="info-row">
            <div className="info-text-content">
              <h3 className="infosection-title">Serviços Adicionais</h3>
              <p className="info-text">
                Para tornar sua estadia ainda mais especial, oferecemos serviços
                adicionais como decoração romântica, tábuas de frios e piquenique. Tudo é
                preparado com muito carinho para proporcionar uma vivência
                única. Contate-nos para saber mais!
              </p>
            </div>
            <div className="info-image-content">
              <img
                src={require("../assets/servicos.jpg")}
                alt="Tábua de frios"
              />
            </div>
          </div>
        </section>

        <section id="acomodacoes" className="accommodations-section">
          <h3 className="section-title">Nossas Acomodações</h3>
          {loading && (
            <p style={{ textAlign: "center" }}>Carregando acomodações...</p>
          )}
          {error && (
            <p style={{ textAlign: "center", color: "red" }}>{error}</p>
          )}

          {!loading && !error && (
            <div className="accommodations-grid">
              {accommodations.map((accommodation) => (
                <div
                  key={accommodation.acomodacao_id}
                  className="accommodation-card"
                >
                  <img
                    src={
                      accommodation.imagens && accommodation.imagens.length > 0
                        ? `${apiUrl}${accommodation.imagens[0].url}`
                        : sliderImages[6]
                    }
                    alt={accommodation.nome}
                    className="accommodation-image"
                  />
                  <h4 className="accommodation-title">{accommodation.nome}</h4>
                  <p className="accommodation-text">
                    {accommodation.descricao.slice(0, 160)}...
                  </p>
                  <button
                    className="details-button"
                    onClick={() => openModal(accommodation)}
                  >
                    + Detalhes
                  </button>
                </div>
              ))}
            </div>
          )}
        </section>

        <section id="avaliacoes" className="reviews-section">
        <h3 className="section-title">O que nossos hóspedes dizem</h3>
        
        <Swiper
          className="reviews-slider"
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          navigation={true}
          pagination={{ clickable: true }}
          breakpoints={{
            768: { 
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="review-card">
                <div className="review-header">
                  <h4 className="review-platform">{review.platform}</h4>
                  <div className="review-rating">
                    <strong>{review.rating}</strong>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                </div>
                <p className="review-body">"{review.text}"</p>
                <div className="review-footer">
                  <div className="review-author-info">
                    <strong>{review.author}</strong>
                    <span>{review.date}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

        <ReactModal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          className="modal"
          overlayClassName="overlay"
        >
          {selectedAccommodation && (
            <div className="acomodacao-modal-content">
              <h2 className="h2-homepage">{selectedAccommodation.nome}</h2>
              <div className="gallery">
                {selectedAccommodation.imagens && selectedAccommodation.imagens?.length > 0 ?
                  selectedAccommodation.imagens?.length > 1 ? (<div className="gallery-container">
                    <button onClick={prevImage} className="gallery-button prev-button">
                      {"<"}
                    </button>
                    <img
                      src={`${apiUrl}${selectedAccommodation.imagens[currentImageIndex]?.url}`}
                      className="gallery-image"
                    />
                    <button onClick={nextImage} className="gallery-button next-button">
                      {">"}
                    </button>
                  </div>) : (
                    <div className="gallery-container">
                      <img
                        src={`${apiUrl}${selectedAccommodation.imagens[currentImageIndex]?.url}`}
                        alt={selectedAccommodation.nome}
                        className="gallery-image"
                      />
                    </div>
                  )
                  : (
                    <p>Esta acomodação não possui imagens.</p>
                  )}
              </div>
              <hr />
              <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <strong>Descrição:</strong>
              </p>
              <p style={{ marginBottom: "20px" }}>
                {selectedAccommodation.descricao}
              </p>
              <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <strong>Características:</strong>
              </p>
              <div className="features-container">
                {selectedAccommodation.caracteristicas.map((c) => (
                  <div key={c.nome} className="feature-item">
                    <FontAwesomeIcon icon={featureIcons[c.icone?.split("fa")[1]?.toLowerCase() || ""]} />
                    <span>{c.nome}</span>
                  </div>
                ))}

                {selectedAccommodation.caracteristicas.length === 0 && (
                  <p>Nenhuma característica especial registrada.</p>
                )}
              </div>

              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <strong>Diárias Mínimas: </strong>
                {selectedAccommodation.min_diaria}
                {" "}
                <HelpTooltip content="A quantidade mínima de diárias necessárias para reservar esta acomodação." />
              </div>
              <div
                className="booking-section"
                style={{ marginBottom: "24px", textAlign: "center" }}
              >
                <label>
                  <strong>Data de Entrada:</strong>{" "}
                  <input
                    type="date"
                    name="checkin"
                    className="date-input"
                    value={checkin}
                    min={hoje}
                    onChange={(e) => setCheckin(e.target.value)}
                  />
                </label>
                <span style={{ margin: "0 10px" }}></span>
                <label>
                  <strong>Data de Saída:</strong>{" "}
                  <input
                    type="date"
                    name="checkout"
                    className="date-input"
                    value={checkout}
                    min={checkin || hoje}
                    onChange={(e) => setCheckout(e.target.value)}
                  />
                </label>
              </div>

              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <button onClick={handleReservarAgora} className="button">
                  Reservar agora
                </button>
              </div>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button onClick={closeModal} className="button">
                  Fechar
                </button>
              </div>
            </div>
          )}
        </ReactModal>
      </main>

      <footer className="footer">
        <div className="footer-top">
          <div className="footer-endereco">
            Estrada do Colono
            <br />
            Mato Branco de Baixo
            <br />
            Imbituva - PR, CEP 84430-000
          </div>
          <div className="footer-contato">
            +55 42 9 9933-2999 (Graciele)
            <br />
            +55 42 9 9129-4333 (Junior)
          </div>
        </div>
        <p>
          © 2025 Pousada Chácara dos Pinheiros. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
